var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.8580322,5C17.4109497,3.27948,15.8587036,2,14,2s-3.4109497,1.27948-3.8580322,3H0v2h10.1419678 C10.5890503,8.72052,12.1412964,10,14,10s3.4109497-1.27948,3.8580322-3H32V5H17.8580322z M14,8c-1.1025391,0-2-0.8974609-2-2 s0.8974609-2,2-2s2,0.8974609,2,2S15.1025391,8,14,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12c-1.8587036,0-3.4109497,1.27948-3.8580322,3H0v2h20.1419678C20.5890503,18.72052,22.1412964,20,24,20 s3.4109497-1.27948,3.8580322-3H32v-2h-4.1419678C27.4109497,13.27948,25.8587036,12,24,12z M24,18c-1.1025391,0-2-0.8974609-2-2 s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,18,24,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,22c-1.8587036,0-3.4109497,1.27948-3.8580322,3H0v2h4.1419678C4.5890503,28.72052,6.1412964,30,8,30 s3.4109497-1.27948,3.8580322-3H32v-2H11.8580322C11.4109497,23.27948,9.8587036,22,8,22z M8,28c-1.1025391,0-2-0.8974609-2-2 s0.8974609-2,2-2s2,0.8974609,2,2S9.1025391,28,8,28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSmall);
export default __webpack_public_path__ + "static/media/filter--small.b08a54cdc02f03586335f00746b2f5f1.svg";
export { ForwardRef as ReactComponent };